<template>
  <div
    class="add-ons__skill-dive"
    v-if="!userHasSkillDive && !isOnePlanAvailable && showSkillDiveAddOns"
  >
    <div
      :class="[
        'add-ons__skill-dive-wrapper',
        skillDiveToggler && 'add-ons__skill-dive-wrapper--show',
      ]"
    >
      <div
        @click="skillDiveToggler = !skillDiveToggler"
        :class="[
          'add-ons__skill-dive-placeholder',
          skillDiveToggler && 'add-ons__skill-dive-placeholder--show',
        ]"
      >
        <div class="add-ons__skill-dive-placeholder-text">
          <img
            :src="skillDiveLogoBadge"
            alt="Skill Dive Experience"
            class="add-ons__skill-dive-placeholder-logo"
          />
        </div>
        <Pill infoWhite v-if="selectedItemsSD > 0"> {{ selectedItemsSD }} selected </Pill>
        <ChevronDownIcon class="add-ons__chevron" />
      </div>
      <div
        :class="[
          'add-ons__skill-dive-items-wrapper',
          skillDiveToggler && 'add-ons__skill-dive-items-wrapper--show',
        ]"
      >
        <PlanSkillDiveItemCard asAddOns />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Pill from '@/components/shared/Pill.vue'
import ChevronDownIcon from '@/assets/icons/chevron_down.svg'
import CONSTANTS from '@/constants'
import skillDiveLogo from '@/assets/images/hero-section/skill-dive/skill-dive-logo.png'
import PlanSkillDiveItemCard from '@/components/plan-item-card/PlanSkillDiveItemCard.vue'

export default {
  name: 'AddOnsSkillDiveItems',
  components: {
    Pill,
    ChevronDownIcon: { ...ChevronDownIcon, name: 'ChevronDownIcon' },
    PlanSkillDiveItemCard,
  },
  data() {
    return {
      skillDiveToggler: false,
      selectedItemsSD: 0,
      skillDiveLogoBadge: skillDiveLogo,
    }
  },
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
    }),
    ...mapGetters({
      userHasSkillDive: 'subscriptions/userHasSkillDive',
    }),
    showSkillDiveAddOns() {
      const plan = this.shoppingCart.find(
        item => item.merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL
      )
      if (!plan) return true
      return plan && plan.selectedAsAddOns
    },
  },
  watch: {
    shoppingCart: {
      immediate: true,
      handler(items) {
        const { PLANS } = CONSTANTS
        const cartHasSkillDive = items.find(i => i.merchant_id === PLANS.SKILL_DIVE_ANNUAL)
        if (cartHasSkillDive) {
          this.selectedItemsSD = cartHasSkillDive.addOnsOnCart.length
        } else {
          this.selectedItemsSD = 0
        }
        this.$forceUpdate()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.add-ons__skill-dive {
  cursor: pointer;
  &-wrapper {
    height: 55px;
    background: var(--gray-3);
    border-radius: 20px;
    transition: 0.3s all ease-in-out;
    &--show {
      height: 100%;
    }
  }
  &-placeholder {
    height: 55px;
    border-radius: 20px;
    background: linear-gradient(90deg, rgba(51, 51, 51, 1) 60%);
    background-position: center right;
    background-image: var(--skill-dive-addons-svg-bg);
    background-repeat: no-repeat;
    display: flex;
    padding: 5px 30px;
    align-items: center;
    font-weight: 700;
    justify-content: space-between;
    gap: 10px;
    font-size: rem(16px);
    line-height: rem(23px);
    @include tablet {
      font-size: rem(20px);
      line-height: rem(26px);
    }
    .pill {
      white-space: nowrap;
      margin-left: auto;
    }
    &--show {
      border-radius: 20px 20px 0 0;
    }
    &-logo {
      width: 130px;
      height: 25px;
    }
  }
  &-items-wrapper {
    width: 100%;
    height: 0px;
    transition: 0.2s all ease-in-out;
    opacity: 0;
    padding: 20px;
    display: flex;
    flex-flow: column;
    gap: 5px;
    z-index: -1;
    position: relative;
    &--show {
      opacity: 1;
      height: 100%;
      cursor: auto;
      z-index: 1;
    }
  }
}
</style>
